"use client";

import { PreviewCloudinaryImage } from "@/features/previews/shared/components/PreviewCloudinaryImage";
import { SocialMediaBlock } from "@/components/SocialMediaBlock";
import { Typography } from "@/components/Typography";
import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { useSocialData } from "./hooks";
import type { QRProps } from "@/contexts/QREditorContext/types";

import "./SocialTemplate.scss";

export const SocialTemplate = (props: QRProps<"social">) => {
  const { isInitialPreview, data, socialLinks, imageSrc, hasValidSocials } = useSocialData(props);

  if (!data) {
    return null;
  }

  const { headline, description, themeColor } = data;

  return (
    <PhoneLayout
      page="social"
      dataQA="preview-social-container"
      backgroundColor="white"
      isInitPreview={isInitialPreview}
      hasIncludeBrowser
    >
      <div
        className="social-template"
        style={{
          backgroundColor: themeColor?.backgroundColor,
        }}
      >
        {imageSrc && (
          <div className="social-template__image-container">
            <PreviewCloudinaryImage
              src={imageSrc}
              variant="hero"
              alt="Social media preview"
              isInitPreview={Boolean(isInitialPreview)}
              className="social-template__image"
              placeholderClass="skeleton-placeholder__links__image"
            />
          </div>
        )}

        <div className="social-template__content">
          <Typography
            Tag="p"
            classname="u-bold social-template__title"
          >
            {headline}
          </Typography>

          {description && (
            <Typography
              Tag="p"
              size="s"
              classname="u-spacing-0 social-template__description"
            >
              {description}
            </Typography>
          )}
        </div>

        <div
          className="social-template__divider"
          style={{
            backgroundColor: themeColor?.buttonColor,
          }}
        />

        {hasValidSocials && (
          <div className="social-template__links">
            {socialLinks.map((link) => (
              <SocialMediaBlock
                key={link.id}
                socialNetwork={link}
              />
            ))}
          </div>
        )}
      </div>
    </PhoneLayout>
  );
};
